// extracted by mini-css-extract-plugin
export default {"wrapper":"DataBanner_wrapper__9oY0s","title":"DataBanner_title__xFGS7","dataBanneContainer":"DataBanner_dataBanneContainer__p-jHE","bigText":"DataBanner_bigText__3o1vo"};